<template>
	<div>
		<RadioGroup
			v-model="type"
			:options="typeOptions"
			@input="emitChangeEvent"
		/>
		<SelectInline
			v-if="itemsEligible"
			v-model="items"
			:characteristic-items="meta.businessModel"
			:characteristic-type="meta.businessModelType"
			class="mt-4"
			label-type="application"
			@input="emitChangeEvent"
		/>
	</div>
</template>
<script>
import SelectInline from "@/vue/characteristic/SelectInline";
import {arrayIsNotEmpty} from "@/helper/Array";
import RadioGroup from "@/vue/common/form/RadioGroup";
import {isDefined} from "@/helper/Value";
import {mapState} from "vuex";

export default {

	components: {
		RadioGroup,
		SelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	mounted ()
	{
		this.emitChangeEvent();
	},

	data ()
	{
		let type = 'irrelevant';
		let items = undefined;

		if (this.value)
		{
			if (this.value.none === true)
			{
				type = 'none';
			}

			if (this.value.desired)
			{
				items = this.value.desired;
				type = 'yes';
			}
		}

		return {
			type,
			items,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		typeOptions ()
		{
			return [
				{value: 'irrelevant', text: 'Egal'},
				{value: 'yes', text: 'Ja'},
				{value: 'none', text: 'Nein'},
			];
		},
		itemsEligible ()
		{
			return this.type === 'yes';
		},
		valid ()
		{
			if (!isDefined(this.type))
			{
				return false;
			}

			if (this.type !== 'yes')
			{
				return true;
			}

			return arrayIsNotEmpty(this.items);
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				none: this.type === 'none',
				desired: this.itemsEligible
					? this.items
					: null,
			});
		},
	}
}
</script>
